<template>
  <div class="container-wrapper">
    <el-header>
      <div class="header-left">
        <img src="@/assets/image/icon.png" alt="">
        <span>评标系统</span>
      </div>
      <div class="header-right">
        <span style="margin-right: 15px;">欢迎您:{{ expertInfo.expertName }}</span>
        <span style="margin-right: 15px;">职位:{{ expertInfo.role === 1 ? '组长' : '成员' }}</span>
        <el-button type="primary" @click="handleClarification" round>澄清</el-button>
        <el-button type="primary" @click="handleLogout" round>退出登录</el-button>
      </div>
    </el-header>
    <el-main class="el-main">
      <div class="el-main-content">
        <div class="el-main-content-header">
          <div class="header-title">招标列表</div>
        </div>
        <router-view></router-view>
      </div>
    </el-main>
    <el-dialog title="需要投标人澄清的内容" :visible.sync="clarifyDialogVisible" width="100%" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-card>
        <el-form :model="clarifyForm" label-width="140px" style="text-align: start;">
          <el-form-item label="选择标段">
            <el-select v-model="clarifyForm.section" placeholder="请选择标段" filterable style="width: 50%"
              @change="getClarifySections">
              <el-option v-for="opt in clarifySections" :key="opt.bidSectionCode" :label="opt.bidSectionName"
                :value="opt.bidSectionCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="提交单位名称" v-if="clarifyForm.section">
            <el-select v-model="clarifyForm.company" placeholder="请选择提交单位" filterable style="width: 50%">
              <el-option v-for="opt in clarifyCompanies" :key="opt.userId" :label="opt.userName" :value="opt.userId" />
            </el-select>
          </el-form-item>
          <el-form-item label="要求澄清问题名称">
            <el-input v-model="clarifyForm.title" placeholder="请输入问题名称" style="width: 50%" />
          </el-form-item>
          <el-form-item label="最晚回复时间">
            <app-date-picker v-model="clarifyForm.deadline" type="datetime" placeholder="选择日期时间" style="width: 50%"
              value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item label="内容文本">
            <el-input v-model="clarifyForm.content" type="textarea" :rows="4" maxlength="200" show-word-limit
              placeholder="请输入澄清内容(不超过200字)" />
          </el-form-item>
          <el-form-item label="附件">
            <div style="color:#909399; text-align: start;">
              仅支持文件类型: jpg、zip、rar; 单个文件不要超过15MB;
            </div>
            <el-upload ref="clarifyUpload" action="#" :auto-upload="false" :show-file-list="false"
              :on-change="onAttachmentChange" :before-upload="() => false" :accept="uploadAccept">
              <el-button type="primary">上传附件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label-width="0">
            <el-table :data="attachmentList" border style="width: 100%">
              <el-table-column prop="name" label="文件名" min-width="200" />
              <el-table-column prop="type" label="文件类型" width="120" />
              <el-table-column label="预览" width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="previewAttachment(scope.row)"
                    :disabled="!scope.row.previewable">预览</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="uploadTime" label="上传时间" width="180" />
              <el-table-column prop="uploader" label="上传人" width="120" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="removeAttachment(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submitClarification">提交</el-button>
      </el-card>
      <!-- 澄清记录表格 -->
      <div style="margin-top: 10px; text-align: start;">
        <el-table :data="clarifyRecords" border style="width: 100%"
          :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
          :cell-style="{ color: '#303133' }">
          <el-table-column type="index" label="NO." width="80" align="center"></el-table-column>
          <el-table-column prop="sectionName" label="标段名称" min-width="160"></el-table-column>
          <el-table-column prop="userName" label="提交单位名称" min-width="160"></el-table-column>
          <el-table-column prop="question" label="问题标题" min-width="160"></el-table-column>
          <el-table-column prop="content" label="问题内容" min-width="240" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="提交时间" width="180" align="center"></el-table-column>
          <el-table-column prop="lastReplyTime" label="最晚回复时间" width="180" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.replyContent === '' || scope.row.replyContent === null" style="color: red;">未回复</span>
              <span v-else>已回复</span>
            </template>
          </el-table-column>
          <el-table-column prop="replyContent" label="回复内容" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="replyTime" label="回复时间" width="180" align="center"></el-table-column>
          <!-- <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="removeClarifyRecord(scope.$index)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { saveClarify, getEvaluationInfo, getCommitteeSectionList, getDecryptCompanyList, getClarifyList, getAgentReview } from '@/api/modules/evaluation'
import Cookies from 'js-cookie'
import { timeUtils } from '@/utils/base'



export default {
  name: 'ExpertEvaluation',
  data() {
    return {
      fileBindId: '',
      sectionCode: '',
      activeName: 'first',
      clarifyDialogVisible: false,
      clarifyForm: { section: '', company: '', title: '', deadline: '', content: '' },
      clarifySections: [],
      clarifyCompanies: [{ label: '单位A', value: 'c1' }, { label: '单位B', value: 'c2' }],
      uploadAccept: '.jpg,.zip,.rar',
      attachmentList: [],
      clarifyRecords: [],
      expertInfo: {}
    }
  },
  mounted() {
    this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
    this.getEvaluationInfo()
  },
  methods: {
    // 获取专家信息
    async getEvaluationInfo() {
      const res = await getEvaluationInfo()
      if (res && res.code === 200) {
        this.expertInfo = res.data
        console.log('---3112');
        
        console.log(res.data);
        Cookies.set('role', res.data.role)
        Cookies.set('title', res.data.sectionName)
        this.getAgentReview()
      } else {
        this.$message.error((res && res.msg) || '获取专家信息失败')
      }
    },


    getAgentReview() {
      
      const sectionCode = "M1301005672000167001001"
      getAgentReview({ sectionCode: sectionCode }).then(res => {
        if (res.code === 200) {
          console.log(res.data);
        }
      }).catch(err => {
        console.error('获取甲方代表资格审查失败:', err)
      })
    },


    //获取投标单位
    getClarifySections(vl) {
      console.log(vl);
      this.getDecryptCompanyList(vl)
      this.sectionCode = vl
      this.getClarifyList()
    },
    //获取解密单位
    getDecryptCompanyList(sectionCode) {
      getDecryptCompanyList(sectionCode
      ).then(res => {
        if (res && res.code === 200) {
          this.clarifyCompanies = res.data;
        } else {
          this.$message.error((res && res.msg) || '获取解密单位失败')
        }
      })
    },
    // 登出
    handleLogout() {
      this.$router.push({ path: '/login' })
    },
    // 澄清
    handleClarification() {
      this.getCommitteeSectionList()
    },
    // 获取标段列表
    async getCommitteeSectionList() {
      const res = await getCommitteeSectionList(Cookies.get('committeeId'))
      if (res && res.code === 200) {
        this.clarifyDialogVisible = true
        this.clarifySections = res.data
      } else {
        this.$message.error((res && res.msg) || '获取标段失败')
      }
    },

    async onAttachmentChange(file, fileList) {
      const isAllowedExt = (name) => /\.(jpg|zip|rar)$/i.test(name || '')
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      if (!isAllowedExt(file.name)) {
        this.$message.error('仅支持 jpg/zip/rar 格式')
        return
      }
      if (file.size / 1024 / 1024 > 15) {
        this.$message.error('文件大小不能超过 15MB')
        return
      }
      try {
        file.raw.fileType = ext
      } catch (e) {
        this.$message.error('上传失败')
        return
      }
      try {
        const res = await doFileUpload(file.raw, {
          fileBindId: this.fileBindId,
          onProgress: (p) => { }
        })
        if (!res || res.success === false) {
          this.$message.error((res && res.message) || '上传失败')
          return
        }
        const isImage = /\.(jpg|jpeg)$/i.test(file.name)
        const url = res.filePath || (isImage ? URL.createObjectURL(file.raw) : '')
        const now = new Date()
        const pad = (n) => (n < 10 ? '0' + n : '' + n)
        const ts = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
        this.attachmentList.push({
          name: file.name,
          type: ext,
          url,
          previewable: /\.(jpg|jpeg)$/i.test(file.name),
          uploadTime: ts,
          uploader: '当前用户',
          fileGuid: res.fileGuid,
          uploadFileId: res.uploadFileId,
          fileId: res.fileId,
          filePath: res.filePath
        })
        this.$message.success('上传成功')
      } catch (err) {
        this.$message.error((err && err.message) || '上传失败')
      }
    },
    // 预览附件
    previewAttachment(row) {
      if (row.url) {
        window.open(row.url, '_blank')
      }
    },
    // 删除附件
    removeAttachment(index) {
      this.attachmentList.splice(index, 1)
    },
    //删除澄清记录
    removeClarifyRecord(index) {
      this.clarifyRecords.splice(index, 1)
    },
    // 提交澄清
    submitClarification() {
      this.saveClarify()
    },
    // 保存澄清请求
    saveClarify() {
      console.log(this.clarifyForm);
      const data = {
        bidCompanyId: this.clarifyForm.company,//投标单位id
        content: this.clarifyForm.content,//内容
        fileBindId: this.fileBindId,//文件绑定id
        lastReplyTime: timeUtils.formatTime(this.clarifyForm.deadline),//回复时间
        question: this.clarifyForm.title,//问题
        sectionCode: this.sectionCode

      }
      saveClarify(data).then(res => {
        if (res.code === 200) {
          this.$message.success('已提交澄清内容')
          this.clarifyDialogVisible = false
          this.getClarifyList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取澄清列表
    getClarifyList() {
      getClarifyList(this.sectionCode).then(res => {
        if (res.code === 200) {
          this.clarifyRecords = res.data
          
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
.container-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url('@/assets/image/openHallbg.jpg');
  padding: 0px 20px;
  padding-bottom: 20px;

  .el-header {

    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;

      img {
        width: 150px;
        height: 50px;
      }

      span {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        margin-left: 10px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: white;
    }
  }

  .el-main {
    flex: 1;
    border-radius: 15px;

    .el-main-content {
      width: 100%;
      .el-main-content-header {
        width: 100%;
        background-color: rgba(243, 246, 249, 1);
        padding: 0px 2%;
        height: 50px;
        text-align: start;
        border-radius: 15px 15px 0 0;
        border-bottom: 1px solid #e4e7ed;

        .header-title {
          background-color: white;
          width: 25%;
          height: 100%;
          border-left: 1px solid #e4e7ed;
          border-right: 1px solid #e4e7ed;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }
}
</style>